import {
    dehydrate,
    type DehydratedState,
    hydrate,
    QueryClient,
    VueQueryPlugin,
    type VueQueryPluginOptions
} from '@tanstack/vue-query';

import { defineNuxtPlugin, useState } from '#imports';

export default defineNuxtPlugin({
    name: 'tanstack',
    parallel: true,
    dependsOn: ['pinia'],
    async setup(nuxtApp) {
        const vueQueryState = useState<DehydratedState | null>('vue-query');

        const queryClient = new QueryClient({
            defaultOptions: {
                queries: { staleTime: 5000 }
            }
        });

        const options: VueQueryPluginOptions = { queryClient };

        nuxtApp.vueApp.use(
            VueQueryPlugin,
            options
        );

        if (import.meta.server || process.server) {
            nuxtApp.hooks.hook(
                'app:rendered',
                () => {
                    vueQueryState.value = dehydrate(queryClient);
                }
            );
        }

        if (import.meta.client || process.client) {
            nuxtApp.hooks.hook(
                'app:created',
                () => {
                    hydrate(
                        queryClient,
                        vueQueryState.value
                    );
                }
            );
        }

        return {
            provide: {
                queryClient
            }
        };
    }
});
